import React from "react";

import { Card, CardBody, CardHeader, Col, Button } from "reactstrap";

import { Fade } from "react-reveal";

const WebsiteCard = ({ data }) => {
	return (
		<Col lg="6">
			<Fade bottom duration={1000} distance="40px">
				<Card className="shadow-lg--hover shadow mt-4">
				<CardHeader className="p-0">
					<img src={data.img} className="w-100 rounded-top"/>
                </CardHeader>
					<CardBody>
						<div className="d-flex px-3">
							<div className="pl-4">
								<h3>{data.name}</h3>
								<p className="description mt-3">{data.desc}</p>
								{data.github ? (
									<Button
										className="btn-icon"
										color="github"
										href={data.github}
										target="_blank"
									>
										<span className="btn-inner--icon">
											<i className="fa fa-github mr-2" />
										</span>
										<span className="nav-link-inner--text ml-1">
											Open Code
										</span>
									</Button>
								) : null}
								{data.link ? (
									<Button
										className="btn-icon"
										color="success"
										href={data.link}
										target="_blank"
									>
										<span className="btn-inner--icon">
											<i className="fa fa-arrow-right mr-2" />
										</span>
										<span className="nav-link-inner--text ml-1">
											Open
										</span>
									</Button>
								) : null}
							</div>
						</div>
					</CardBody>
				</Card>
			</Fade>
		</Col>
	);
};

export default WebsiteCard;
